module.exports = __webpack_public_path__ + "static/media/Preloader.58c73352.svg";